import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Pane extends Component {
  displayName: 'Pane'

  static propTypes = {
    comp: PropTypes.func.isRequired,
    label: PropTypes.string,
    message: PropTypes.string,
  }

  render() {
    const Comp = this.props.comp
    if (Comp) {
      return <Comp message={this.props.message} />
    }

    return <div>{`Your content for ${this.props.label} goes here.`}</div>
  }
}

export default Pane
